<script lang="ts">
  import { mdiYoutube, mdiLinkedin, mdiPencilOutline } from '@mdi/js';
</script>

<footer class="bg-white border-t border-am-black-45 w-full overflow-hidden">
  <div class="flex flex-col gap-8 lg:gap-0 lg:flex-row w-full px-4 lg:px-24">
    <!-- Newsletter Subscription -->
    <div class="pt-6 lg:py-14 md:pl-8 lg:pr-16 w-full">
      <div>
        <div class="flex items-center gap-4">
          <img src="/blue.png" alt="AddMeetings Logo" class="w-16 mb-4" />
          <h3 class="text-3xl font-bold mb-2">AddMeetings</h3>
        </div>
        <p class="text-am-black-75 mb-4 max-w-sm">
          Reduce noise, save time, and get more meetings with the right people.
        </p>
      </div>
      <p class="mt-16 text-sm text-am-white-60 hidden lg:block">Copyright &copy; 2025 - Add Meetings AS</p>
    </div>

    <div class="flex flex-col sm:flex-row sm:justify-between w-full gap-8">
      <!-- Navigation Links -->
      <div class="flex flex-col gap-2 md:gap-4 lg:border-l border-am-black-45 md:pl-8 lg:py-8 lg:px-16">
        <!-- Main Navigation -->
        <div class="flex flex-col gap-2 md:gap-4">
          {#each [
            { href: "https://app.addmeetings.com/login", text: "Register / Sign Up" },
            { href: "/for-buyers", text: "For Decision Makers" },
            { href: "/for-sales", text: "For Sales People" },
            { href: "/about", text: "About Us" }
          ] as link}
            <a href={link.href} class="block whitespace-nowrap hover:text-am-blue transition-colors">
              {link.text}
            </a>
          {/each}
        </div>

        <!-- Legal Links -->
        <div class="flex flex-col gap-2 md:gap-4 pt-8">
          {#each [
            { href: "/privacy-policy", text: "Privacy Policy" },
            { href: "/terms-and-conditions", text: "Terms of Service" }
          ] as link}
            <a href={link.href} class="block whitespace-nowrap text-am-black-45 hover:text-am-blue transition-colors">
              {link.text}
            </a>
          {/each}
        </div>
      </div>

      <!-- Social Links -->
      <div class="flex flex-col gap-2 md:gap-5 lg:border-l border-am-black-45 md:pl-8 lg:py-8 lg:px-16 w-fit">
      {#each [
        { href: "https://blog.addmeetings.com/", text: "Blog", icon: mdiPencilOutline },
        { href: "https://www.youtube.com/@AddMeetings", text: "Youtube", icon: mdiYoutube },
        { href: "https://www.linkedin.com/company/add-meetings/", text: "Linkedin", icon: mdiLinkedin }
      ] as social}
        <a 
          href={social.href} 
          target="_blank" 
          class="flex items-center gap-2 hover:text-[#536aff] transition-colors"
        >
          <svg
            class="w-6 h-6"
            viewBox="0 0 24 24"
            stroke-width="1.2"
            stroke="currentColor"
          >
            <path
              fill="none"
              d={social.icon}
            />
          </svg>
          {social.text}
        </a>
      {/each}
      </div>
    </div>

    <p class="my-4 text-sm text-am-white-60 block lg:hidden">Copyright &copy; 2025 - Add Meetings AS</p>
  </div>
</footer>

<style>
  /* Add smooth transitions */
  a {
    -webkit-tap-highlight-color: transparent;
  }

  /* Ensure proper focus states for accessibility */
  a:focus-visible {
    outline: 2px solid #536aff;
    outline-offset: 2px;
  }
</style>
